export default __webpack_public_path__ + "static/media/comments-reply.14aba38d.svg";